<template>
    <nav class="text-center navbar navbar-dark bg-dark justify-content-center fixed-bottom">
        <p class="mb-0 text-muted small">Copyright &copy; ASAHI JAYA PART 2022 - 
        <span class="badge badge-light">v{{ $store.state.version }}</span>
            <a href="https://aplikasipro.com" target="_blank">made by aplikasipro.com</a>
        </p>
    </nav>
</template>

<script>
    export default {
        name: "Footer",
        data() {
            return {};
        }
    };
</script>

<style lang="css" scoped>
</style>
